import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Table from "../../../../../../common/components/table-manager/v1.1/table";

const WhitelistedRoutes = () => {
    const navigate = useNavigate()
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const [showRejectionPopup, setShowRejectionPopup] = useState<boolean>();
    const [itemDetails, setItemDetails] = useState<any>();

    const [columnDefs, setColumnDefs] = useState({});

    const whitelist = [
      {Id: 1, "Name": "", "value": "/api/status-update", CreatedOnUtc: "2024-09-30T06:21:14.954Z"},
      {Id: 2, "Name": "", "value": "/api/order-update", CreatedOnUtc: "2024-09-30T06:21:14.954Z"},
      {Id: 3, "Name": "", "value": "/api/poll", CreatedOnUtc: "2024-09-30T06:21:14.954Z"},
      {Id: 4, "Name": "", "value": "/api/logistics/bap", CreatedOnUtc: "2024-09-30T06:21:14.954Z"},
      {Id: 5, "Name": "", "value": "/api/on_issue_trigger", CreatedOnUtc: "2024-09-30T06:21:14.954Z"},
      {Id: 6, "Name": "", "value": "/api/on_issue_status", CreatedOnUtc: "2024-09-30T06:21:14.954Z"},
      {Id: 7, "Name": "", "value": "/api/lsp_issue_trigger", CreatedOnUtc: "2024-09-30T06:21:14.954Z"},
      {Id: 8, "Name": "", "value": "/api/lsp_issue_status_trigger", CreatedOnUtc: "2024-09-30T06:21:14.954Z"},
      {Id: 9, "Name": "", "value": "/api/on_receiver_recon_trigger", CreatedOnUtc: "2024-09-30T06:21:14.954Z"},
      {Id: 10, "Name": "", "value": "/api/collector_recon", CreatedOnUtc: "2024-09-30T06:21:14.954Z"},
      {Id: 11, "Name": "", "value": "/api/status", CreatedOnUtc: "2024-09-30T06:21:14.954Z"},
      {Id: 12, "Name": "", "value": "/api/update", CreatedOnUtc: "2024-09-30T06:21:14.954Z"}
    ]

    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'Name', headerName: 'Name', sortable: true, filter: true, filterType: 'text' },
            { field: 'value', headerName: 'Route', sortable: true, filter: true, filterType: 'text' },
            { field: 'CreatedOnUtc', headerName: 'Whitelisted Date', sortable: true, filter: true, filterType: 'text' },
        ]);
    }

    const handleReloadData = () => {

    }

    const handleBlacklisting = () => {

    }

    const additionButtons: any = [    
      {
        svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
            <title>Blacklist BAP</title>
            <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
          </svg>,
        // name: 'Initiate Settlement',
        callback: () => handleBlacklisting(),
      },      
      {
        svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
            <title>Reload this table</title>
            <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>,
        // name: 'Reload',
        callback: () => handleReloadData(),
      },
    ];

    const handleEdit = (data: any) => {
        console.log('data', data)
        // navigate(`/gateway/commerce/bpp/${data.Id}`)
    }

    const handleDelete = (data: any) => {

    }

    const back = () => {
        navigate(-1)
    }

    const closeModal = () => {
        setShowRejectionPopup(false)
    }


    useEffect(() => {
        createColumnDefs()
    }, []
    )

    return (
        <>
            <Table
                columnData={columnDefs}
                rowData={whitelist}
                enableFilter={true} 
                additionButtons={additionButtons}
                // onViewList={handleViewList}
                onEdit={handleEdit}
                onDelete={handleDelete}
                checkboxConfig={{
                    allowMultiSelect: true,
                    defaultSelectedIds: [],
                    isDisabled: false,
                    keyColumn: 'Id',
                }}
                headingName="Whitelisted Routes"
            />            
        </>
    )
};

export default WhitelistedRoutes;


